import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { mienGiamSoTienApi } from "../../../api/mien-giam/mienGiamSoTienApi";
import { NotifyHelper } from "../../../helpers/toast";
import {
  IMienGiamSoTienDuyetRequest,
  IMienGiamSoTienPagingRequest,
  IMienGiamSoTienSaveRequest,
} from "../../../model/request/mien-giam/IMienGiamSoTienRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eMienGiamSoTienActionIds,
  IMienGiamSoTienActionTypes,
} from "../../action-types/mien-giam/IMienGiamSoTienActions";
import { rootActions } from "../../actions/rootActions";

export function* mienGiamSoTienSaga(): any {
  yield takeLatest(eMienGiamSoTienActionIds.LOAD_START, loadWorker);
  yield takeEvery(eMienGiamSoTienActionIds.SAVE_START, saveWorker);
  yield takeEvery(eMienGiamSoTienActionIds.DUYET_START, duyetWorker);
  yield takeEvery(eMienGiamSoTienActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IMienGiamSoTienActionTypes): any {
  const res: IBaseRespone = yield call(
    mienGiamSoTienApi.SelectPaging,
    action.payload as IMienGiamSoTienPagingRequest,
  );
  if (res.is_success) {
    yield put(rootActions.mienGiam.mienGiamSoTien.LOAD_SUCCESS(res.data));
  } else {
    NotifyHelper.Error(res.message ?? "Không lấy được danh sách");
    yield put(
      rootActions.mienGiam.mienGiamSoTien.LOAD_ERROR(res.message ?? "Có lỗi"),
    );
  }
}

function* saveWorker(action: IMienGiamSoTienActionTypes): any {
  const payload = action.payload as IMienGiamSoTienSaveRequest;
  const res: IBaseRespone = yield call(mienGiamSoTienApi.Saves, payload);
  if (res.is_success) {
    NotifyHelper.Success(
      payload.is_duyet ? "Đã lưu và duyệt" : "Đã lưu thiết lập miễn giảm",
    );
    yield put(rootActions.mienGiam.mienGiamSoTien.SAVE_SUCCESS(""));
  } else {
    NotifyHelper.Error(res.message ?? "Lưu không thành công");
    yield put(
      rootActions.mienGiam.mienGiamSoTien.SAVE_ERROR(res.message ?? "Có lỗi"),
    );
  }
}

function* duyetWorker(action: IMienGiamSoTienActionTypes): any {
  const payload = action.payload as IMienGiamSoTienDuyetRequest;
  const res: IBaseRespone = yield call(mienGiamSoTienApi.SetDuyet, payload);
  if (res.is_success) {
    NotifyHelper.Success(payload.is_duyet ? "Đã duyệt" : "Đã hủy duyệt");
    yield put(rootActions.mienGiam.mienGiamSoTien.DUYET_SUCCESS(""));
  } else {
    NotifyHelper.Error(res.message ?? "Không thực hiện được");
    yield put(
      rootActions.mienGiam.mienGiamSoTien.DUYET_ERROR(res.message ?? "Có lỗi"),
    );
  }
}

function* deleteWorker(action: IMienGiamSoTienActionTypes): any {
  const res: IBaseRespone = yield call(
    mienGiamSoTienApi.Deletes,
    action.payload as number[],
  );
  if (res.is_success) {
    NotifyHelper.Success("Đã xóa");
    yield put(rootActions.mienGiam.mienGiamSoTien.DELETE_SUCCESS(""));
  } else {
    NotifyHelper.Error(res.message ?? "Xóa không thành công");
    yield put(
      rootActions.mienGiam.mienGiamSoTien.DELETE_ERROR(res.message ?? "Có lỗi"),
    );
  }
}
